import axios from "axios";
import moment from "moment";
import { returnURL, returnJson } from "../ApiSettings/returnURL";
const BaseUrl = "api/Button/Post";
const CallsUrl = "api/Calls/List";

// Get Call's History
export async function getHistoryApi(url, dateFrom, dateTo, token) {
  let url_request = url + CallsUrl;
  url_request = returnURL(url_request);

  //Transform Dates
  let eDate = new Date(dateTo);
  let sDate = new Date(dateFrom);

  console.log("End DAte :", eDate);
  console.log("Start DAte :", sDate);

  //To set date as format d/M/yyyy for querry
  let startD =
    sDate.getDate() + "/" + (sDate.getMonth() + 1) + "/" + sDate.getFullYear();
  let endD =
    eDate.getDate() + "/" + (eDate.getMonth() + 1) + "/" + eDate.getFullYear();

  let page = "client.aspx";
  let query = {
    calltype: "call",
    tp: "iqu_history",
    datefrom: startD,
    dateto: endD,
    token: token,
  };

  // let json = returnJson(page, query);

  // return await axios.post(url_request, json, {
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  //   timeout: 60000,
  // });

  let params = {
    returnReservations: false,
    maxResults: 50,
    startTimeStampOfCalls: moment(sDate).unix(),
    endTimeStampOfCalls: moment(eDate).unix(),
    needAllCalls: true,
    filterOnCheckedStatus: 0,
  };

  return await axios.post(url_request, params, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    timeout: 60000,
  });
}
